import { BenefitItems } from 'all-in-one-shared-api';
import i18n from 'i18n';

interface UsageItem {
  maxDescription: string;
  maxDescriptionCn: string;
  maxValue: string;
  valueUsed: string;
}

export const getUsageItemValue = (item: BenefitItems): Partial<UsageItem> => {
  const { t } = i18n;
  const {
    paidAmount,
    limitUsed,
    limit,
    limitDescription,
    limitDescriptionCn,
    maxAmount,
    maxAmountDescription,
    maxAmountDescriptionCn,
  } = item;

  if (limit) {
    return {
      maxDescription: limitDescription ?? '',
      maxDescriptionCn: limitDescriptionCn ?? '',
      maxValue: `${limit} ${t('benefits.visits')}`,
      valueUsed: `${parseInt(limitUsed ?? '0')} ${t('benefits.visitsUsed')}`,
    };
  }

  if (maxAmount) {
    const isAsCharged = parseInt(maxAmount) >= 999999;
    return {
      maxDescription: maxAmountDescription ?? '',
      maxDescriptionCn: maxAmountDescriptionCn ?? '',
      maxValue: isAsCharged ? t('benefits.asCharged') : `HKD ${Number(maxAmount).toLocaleString()}`,
      valueUsed: `HKD ${paidAmount ?? ''} ${t('common.used')}`,
    };
  }

  return {};
};
